import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'images',
    label: 'Images',
    type: types.ARRAY,
    options: false,
    children: [
      {
        key: 'url',
        label: 'Image URL',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  images: [
    { url: 'https://placehold.it/250/bf4040/000000' },
    { url: 'https://placehold.it/250/2196f3/000000' },
    { url: 'https://placehold.it/250/9c27b0/000000' },
    { url: 'https://placehold.it/250/4caf50/000000' },
    { url: 'https://placehold.it/250/ffeb3b/000000' },
    { url: 'https://placehold.it/250/ff9800/000000' },
    { url: 'https://placehold.it/250/9e9e9e/000000' },
    { url: 'https://placehold.it/250/9e9e9e/000000' }
  ]
};

export default {
  title: 'Image Gallery',
  id: 'ImageGallery',
  propsSchema,
  defaultProps
};
